import { mapModifiers } from "@/utils/funtion";
import { ChangeEvent, ReactNode } from "react";
interface ICheckboxProps {
  id?: string;
  label?: ReactNode;
  handleOnCheck: (e: ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  errorMessage?: string;
  className?: string
}
const Checkbox = ({
  id = `${Math.floor(Math.random() * 10000)}`,
  label,
  handleOnCheck,
  checked = false,
  errorMessage,
  className
}: ICheckboxProps) => {
  return (
    <div 
      className={mapModifiers("checkbox-wrapper", errorMessage?.trim() ? 'error' : '', className)}
    >
      <label htmlFor={id} className="checkbox-label">
        <input
          type="checkbox"
          id={id}
          onChange={handleOnCheck}
          checked={checked}
        />
        <span className="check-box" />
        {label && <span>{label}</span>}
      </label>
      {errorMessage && (
        <div className="checkbox-wrapper-error_message">{errorMessage}</div>
      )}
    </div>
  );
};

export default Checkbox;
